import {
  FocusValidity,
  GlobalBrand,
  GlobalBrandRequest,
  Query,
  QueryChange,
  QueryDetails,
  QueryUses,
  SearchQueryInfo,
  SearchableQuery,
} from "@radarly/models/queries";
export interface QuerySearchOptions {
  includeLabel: boolean;
  includeQueryBody: boolean;
}

export interface Pagination {
  start: number;
  limit: number;
}

export interface QueryRepository {
  getQueryDetails(project: number, focus: number): Promise<QueryDetails>;
  getQueryValidity(query: string): Promise<SearchQueryInfo>;
  searchQueries(
    search: string,
    pagination: Partial<Pagination>,
    options: Partial<QuerySearchOptions>
  ): Promise<{ queries: SearchableQuery[]; total: number }>;
  getQueryUses(project: number, focus: number): Promise<QueryUses>;
  getQueriesUses(project: number, focuses: number[]): Promise<QueryUses[]>;
  getQueryProjectPictures(
    project: number
  ): Promise<{ pictures: { id: number; url: string }[] }>;
  deleteQuery(project: number, focus: number): Promise<void>;
  deleteQueries(
    project: number,
    focuses: number[]
  ): Promise<PromiseSettledResult<number>[]>;
  updateQuery: (query: Query, projectId: number) => Promise<Query>;
  uploadQueryProjectPictures: (
    projectId: number,
    files: File[]
  ) => Promise<{ id: number; url: string }[]>;
  deleteQueryProjectPicture(project: number, pictureId: number): Promise<void>;

  createQuery: (query: Query, projectId: number) => Promise<Query>;
  checkQueryLimit: (
    query: Query,
    projectId: number
  ) => Promise<{ isOverLimit: boolean }>;
  getGlobalBrands: (
    payload: GlobalBrandRequest,
    projectId: number
  ) => Promise<{ data: GlobalBrand[]; total: number }>;
  getFocusValidity: (
    focus: Query,
    projectId: number
  ) => Promise<{ data: FocusValidity }>;
  getQueryChangeLog: (
    project: number,
    focus: number,
    pagination: Pagination
  ) => Promise<{ changelog: QueryChange[]; total: number }>;
}

export const QueryRepositoryUID = Symbol("Radarly/QueryRepository");
